export enum BlackListTypeEnum {
    IPAddress = 1,
    DeviceId = 2,
    Country = 3,
    Email = 4,
    MobileNumber = 5,
}
